import * as React from "react";

function CloudInfrastructureSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g fill="none" stroke="#fff" strokeWidth={2}>
        <path d="M28 18a6 6 0 00-12 0h-2a6 6 0 000 12h16a6 6 0 100-12z" />
      </g>
    </svg>
  );
}

export default CloudInfrastructureSvg;
